import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enCommon from './localization/en/common.json';
import esCommon from './localization/es/common.json';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enCommon },
    es: { translation: esCommon },
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
